<template>
  <el-dialog
    :title="displayText.dialogTitle"
    :visible="true"
    width="670px"
    :close-on-click-modal="false"
    @close="onClose"
  >
    <p v-if="showControl.data" class="text-normal flex gap-[20px]">
      <span>{{ displayText.store }}</span>
      <span>{{ selectRow.name }}</span>
    </p>
    <BaseElForm ref="formBusinessRef" :model="localFormData" :rules="formRules" label-position="top">
      <BaseElFormItem prop="mode" :label="displayText.businessTime" class="mt-[20px]">
        <BaseElRadioGroup v-model="localFormData.mode">
          <BaseElRadio v-for="item in storeBusinessTimeTypeConfig" :key="item.value" :label="$t(item.value)" class="text-sub">{{ $t(item.label) }}</BaseElRadio>
        </BaseElRadioGroup>
      </BaseElFormItem>
      <div v-if="showControl.customWeek" class="special-time mb-[20px]">
        <hr class="mt-[20px] mb-[20px]">
        <p class="content">{{ displayText.descriptionTitle }}</p>
        <ol>
          <li>{{ displayText.descriptionContent1 }}</li>
          <li>{{ displayText.descriptionContent2 }}</li>
        </ol>
        <AddTimes v-if="showControl.customWeekConfigs" :title="displayText.addButtonTitle" :customWeekConfigs="localFormData.customWeekConfigs" isWeek timeStep="00:30" />
      </div>
      <template v-if="showControl.excludedDays">
        <BaseElFormItem prop="excludedDays" :label="displayText.excludeSpecificTime" class="mt-[20px]">
          <BaseElSwitch v-model="localFormData.excludedDays" :active-text="displayText.openText" :inactive-text="displayText.closeText" />
        </BaseElFormItem>
        <BaseElFormItem v-if="showControl.excludeTimeRules" :label="displayText.excludeSpecificPeriod" prop="excludeTimeRule">
          <AddPeriodTimes :excludeTimeRule="localFormData.excludeTimeRules" :omitList="['weekly']" />
        </BaseElFormItem>
      </template>
    </BaseElForm>
    <div slot="footer">
      <BaseElButton plain @click="onClose">{{ displayText.cancelButton }}</BaseElButton>
      <BaseElButton type="primary" @click="onConfirm">{{ displayText.confirmButton }}</BaseElButton>
    </div>
  </el-dialog>
</template>

<script>
import { defineComponent, ref, onMounted, computed } from 'vue'
import AddTimes from '@/components/AddTimes.vue'
import AddPeriodTimes from '@/components/AddPeriodTimes.vue'
import { cloneDeep, get } from 'lodash'
import { storeBusinessTimeTypeConfig } from '@/config/reservation'
import { i18n } from '@/plugins/i18n/i18n'

export default defineComponent({
  name: 'AllStoreListDialog',
  components: { AddTimes, AddPeriodTimes },
  props: {
    data: {
      type: Object,
    },
    formRules: {
      type: Object,
      required: true,
    },
    selectRow: {
      type: Object,
    },
  },
  emits: ['close', 'confirm'],
  setup (props, { emit }) {
    const formBusinessRef = ref(null)
    const localFormData = ref({})

    const onClose = () => {
      emit('close')
    }

    const onConfirm = async () => {
      emit('confirm', localFormData.value)
    }

    onMounted(() => {
      localFormData.value = cloneDeep(props.data)
    })

    const displayText = computed(() => ({
      dialogTitle: '編輯門市營業時間',
      store: '門市',
      businessTime: '營業時間',
      descriptionTitle: i18n.t('businessTimeSettings.description.title'),
      descriptionContent1: i18n.t('businessTimeSettings.description.content1'),
      descriptionContent2: i18n.t('businessTimeSettings.description.content2'),
      addButtonTitle: i18n.t('businessTimeSettings.button.add.title'),
      excludeSpecificTime: '排除特定營業時間',
      excludeSpecificPeriod: '排除特定時段',
      openText: i18n.t('common.open.text'),
      closeText: i18n.t('common.close.text'),
      cancelButton: i18n.t('common.button.cancel.text'),
      confirmButton: i18n.t('common.button.confirm2.text'),
    }))
    const showControl = computed(() => {
      const controls = {
        data: localFormData.value,
        customWeek: get(localFormData.value, 'mode') === 'CustomWeek',
        customWeekConfigs: get(localFormData.value, 'customWeekConfigs'),
        excludedDays: get(localFormData.value, 'mode') !== 'FollowShop',
        excludeTimeRules: get(localFormData.value, 'excludedDays') && get(localFormData.value, 'excludeTimeRules'),
      }
      return controls
    })
    return {
      formBusinessRef,
      localFormData,
      onClose,
      onConfirm,
      storeBusinessTimeTypeConfig,
      displayText,
      showControl,
    }
  },
})
</script>

<style scoped>
</style>
